import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-screenshot-viewer',
    templateUrl: './screenshot-viewer.component.html',
    styleUrls: ['./screenshot-viewer.component.scss'],
    standalone: false
})
export class ScreenshotViewerComponent {
  @Output() close = new EventEmitter<void>();
   // Input property to receive the image URL from the parent
  @Input() imageUrl: string = '';

  // A property to track the current zoom level, starting at 1 (100%)
  zoomLevel: number = 0.8;
  
  // The amount to increase or decrease the zoom by
  private zoomStep: number = 0.2; 
  private maxZoom: number = 4;
  private minZoom: number = 1;
// Replace this with your actual data source
  screenshots: string[] = [
    'path/to/image1.jpg',
    'path/to/image2.jpg',
    'path/to/image3.jpg',
    // ... more image paths
  ]; 

  isModalOpen: boolean = false;
  selectedImage: string | null = null;

  constructor() { }

  ngOnInit(): void {
  }

  // Method called when an image is clicked
  openModal(imageUrl: string): void {
    this.selectedImage = imageUrl;
    this.isModalOpen = true;
  }

  // Method called to close the modal (e.g., from the modal component's close button)
  closeModal(): void {
    this.isModalOpen = false;
    this.selectedImage = null;
  }
   zoomIn(): void {
    if (this.zoomLevel < this.maxZoom) {
      this.zoomLevel += 0.25; // Increase by 25%
    }
  }

  /**
   * Decreases the zoom level of the image, down to a minimum.
   */
  zoomOut(): void {
    if (this.zoomLevel > this.minZoom) {
      this.zoomLevel -= 0.25; // Decrease by 25%
    }
  }
}
